import React from 'react';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { Spin } from 'antd';
import FlatMemberView from './components/FlatMemberView';
import { useMemberList } from './hooks/useMemberList';
import styles from './MemberList.module.scss';
const MODAL_WIDTH = 400;
const MODAL_HEIGHT = 480;
const MemberList = ({ visible, user, contactName, onCancel }) => {
    const { members, loading, error } = useMemberList(user);
    return (React.createElement(Modal, { width: MODAL_WIDTH, bodyStyle: { height: MODAL_HEIGHT, padding: 0, overflow: 'hidden' }, wrapClassName: "memberListModalWrap", footer: null, destroyOnClose: true, centered: true, visible: visible, onCancel: onCancel },
        React.createElement("div", { className: styles.container },
            React.createElement("h2", { className: styles.title }, contactName),
            React.createElement("div", { className: styles.stats },
                "\u5171 ",
                members.length,
                " \u4EBA"),
            React.createElement("div", { className: styles.content },
                error && React.createElement("div", { className: styles.error }, error),
                !error && loading && (React.createElement("div", { className: styles.loading },
                    React.createElement(Spin, null))),
                !error && !loading && React.createElement(FlatMemberView, { members: members })))));
};
export { MemberList };
